import React, { MouseEventHandler } from "react";
import { Link } from "react-router-dom";

interface MainButtonProps {
  titlebtn: string;
  className?: string;
  onClick?: MouseEventHandler<HTMLButtonElement>;
  link?:string
  type ?: boolean 
  disabled?:any
}

const MainButton: React.FC<MainButtonProps> = ({
  titlebtn,
  className,
  onClick,
  link,
  type,
  disabled
}) => {
  return (
    <Link to={link!}>
      <button disabled={disabled}
        className={`bg-graydark text-white text-center max-md:text-sm py-3 px-3 rounded-2xl text-base ${className} hover:bg-[#d46ebb] hover:text-white`}
        onClick={onClick}
        type={type ? `submit` : 'button' }
      >
        {titlebtn}
      </button>
    </Link>
  );
};

export default MainButton;
